import cookie from "cookie"; // eslint-disable-line

export const getAccessToken = () => {
    if(typeof window === 'undefined') return;
    return cookie.parse(document.cookie).token;
}
